import React from 'react'
import BlockInfos from '@/components/HomeNotConnected/BlockInfos'
import BlockLeader from '@/components/HomeNotConnected/BlockLeader'
import HomeCallTeam from '@/components/Home/HomeCallTeam'
import DisplayLogoBrands from './DisplayLogoBrands'

const HomeNotConnected: React.FC = () => {
  return (
    <div>
      <br />
      <DisplayLogoBrands nbMarque={8} folder={'/images/marques-home/'} height={60} width={115} />

      <BlockInfos />

      <BlockLeader />

      <HomeCallTeam />
    </div>
  )
}

export default HomeNotConnected
